/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetTemplateSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetTemplateSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetTemplateSecurityOption3 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetTemplateSecurity = {
  option1?: GetTemplateSecurityOption1 | undefined;
  option2?: GetTemplateSecurityOption2 | undefined;
  option3?: GetTemplateSecurityOption3 | undefined;
};

export type GetTemplateRequest = {
  /**
   * The ID of the prompt template
   */
  id?: string | undefined;
  /**
   * The name of the prompt template
   */
  name?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetTemplateSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetTemplateSecurityOption1$outboundSchema: z.ZodMiniType<
  GetTemplateSecurityOption1$Outbound,
  GetTemplateSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getTemplateSecurityOption1ToJSON(
  getTemplateSecurityOption1: GetTemplateSecurityOption1,
): string {
  return JSON.stringify(
    GetTemplateSecurityOption1$outboundSchema.parse(getTemplateSecurityOption1),
  );
}

/** @internal */
export type GetTemplateSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetTemplateSecurityOption2$outboundSchema: z.ZodMiniType<
  GetTemplateSecurityOption2$Outbound,
  GetTemplateSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getTemplateSecurityOption2ToJSON(
  getTemplateSecurityOption2: GetTemplateSecurityOption2,
): string {
  return JSON.stringify(
    GetTemplateSecurityOption2$outboundSchema.parse(getTemplateSecurityOption2),
  );
}

/** @internal */
export type GetTemplateSecurityOption3$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetTemplateSecurityOption3$outboundSchema: z.ZodMiniType<
  GetTemplateSecurityOption3$Outbound,
  GetTemplateSecurityOption3
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getTemplateSecurityOption3ToJSON(
  getTemplateSecurityOption3: GetTemplateSecurityOption3,
): string {
  return JSON.stringify(
    GetTemplateSecurityOption3$outboundSchema.parse(getTemplateSecurityOption3),
  );
}

/** @internal */
export type GetTemplateSecurity$Outbound = {
  Option1?: GetTemplateSecurityOption1$Outbound | undefined;
  Option2?: GetTemplateSecurityOption2$Outbound | undefined;
  Option3?: GetTemplateSecurityOption3$Outbound | undefined;
};

/** @internal */
export const GetTemplateSecurity$outboundSchema: z.ZodMiniType<
  GetTemplateSecurity$Outbound,
  GetTemplateSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetTemplateSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetTemplateSecurityOption2$outboundSchema),
    ),
    option3: z.optional(
      z.lazy(() => GetTemplateSecurityOption3$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
      option3: "Option3",
    });
  }),
);

export function getTemplateSecurityToJSON(
  getTemplateSecurity: GetTemplateSecurity,
): string {
  return JSON.stringify(
    GetTemplateSecurity$outboundSchema.parse(getTemplateSecurity),
  );
}

/** @internal */
export type GetTemplateRequest$Outbound = {
  id?: string | undefined;
  name?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetTemplateRequest$outboundSchema: z.ZodMiniType<
  GetTemplateRequest$Outbound,
  GetTemplateRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    name: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getTemplateRequestToJSON(
  getTemplateRequest: GetTemplateRequest,
): string {
  return JSON.stringify(
    GetTemplateRequest$outboundSchema.parse(getTemplateRequest),
  );
}
